/**
 * Created by vink on 5/17/2022.
 */
'use strict';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
var PaymentCreditCardFrameController = /** @class */ (function () {
    /* @ngInject*/
    function PaymentCreditCardFrameController($log, $scope, $location, $timeout, $state, $q, $sce, $rootScope, CreditCardService, Util, CartService, AddressService, $filter, SettingsService, Auth, $window, FocusOnService, configurationService) {
        var self = this;
        self.Auth = Auth;
        self.bearerToken = "";
        self.isFrameloaded = true;
        self.paymentURL = "";
        self.$sce = $sce;
        self.$state = $state;
        self.uiRouterState = this.$state.current.name;
        self.iframe = "";
        self.CartService = CartService;
        self._$rootScope = $rootScope;
        self.$window = $window;
        self.CreditCardService = CreditCardService;
        self.settingsService = SettingsService;
        self.$location = $location;
        this.environment = configurationService.getEnvironmentConfiguration();
        this.getToken();
        this.$window.onmessage = function (e) {
            if (typeof e.data === "string") {
                var message = JSON.parse(e.data);
                if (message.type === "Emerson") {
                    if (message.eventtype === "revieworderCardData") {
                        self.reviewOrder(message.data);
                    }
                    else if (message.eventtype === "resize") {
                        if (message.data && message.data.height) {
                            document.getElementById("paymentframeelement").style.height = message.data.height + 50 + 'px';
                        }
                        else {
                            document.getElementById("paymentframeelement").style.height = document.documentElement.clientHeight + 'px';
                        }
                    }
                }
                $scope.$digest();
            }
        };
        self.errors = {
            pageErrorType: '',
            pageErrors: '',
            havePageErrors: false
        };
        self.allowedPaymentTypes = [
            { method: 'Credit Card', allowed: true },
            { method: 'Terms', allowed: false },
            { method: 'COD', allowed: false },
            { method: 'Prepaid', allowed: false }
        ];
        self.selectedPaymentType = 'Credit Card';
        this.getPaymentInformation();
    }
    PaymentCreditCardFrameController.prototype.bannerMessage = function (message) {
        this.errors.pageErrorType = 'warning';
        this.errors.pageErrors = message;
        this.errors.havePageErrors = true;
        this.showAlert = true;
    };
    PaymentCreditCardFrameController.prototype.getToken = function () {
        var _this = this;
        this.Auth.getUserEmail().then(function (email) {
            _this.userEmail = email;
        });
        this.Auth.getToken().then(function (data) {
            _this.bearerToken = data;
            _this.paymentURL = _this.$sce.trustAsResourceUrl(_this.environment.cardManagerAppUrl);
        });
    };
    PaymentCreditCardFrameController.prototype.getPaymentInformation = function () {
        var paymentinfo = this.allowedPaymentTypes;
        this.CreditCardService.getCreditCards().then(function (data) {
            if (data.length) {
                var _loop_1 = function (index) {
                    paymentTypes = data.find(function (d) { return d.paymentType == paymentinfo[index].method; });
                    if (paymentTypes) {
                        paymentinfo[index].allowed = true;
                    }
                };
                var paymentTypes;
                for (var index = 1; index < paymentinfo.length; index++) {
                    _loop_1(index);
                }
            }
        });
    };
    PaymentCreditCardFrameController.prototype.iframeloaded = function () {
        var _this = this;
        var isIframeElement = document.getElementById("paymentframeelement");
        if (isIframeElement && isIframeElement.contentWindow) {
            this.iframe = document.getElementById("paymentframeelement").contentWindow;
            var getEmail = this.Auth.getUserEmail();
            var getAccountInfo = this.settingsService.getAccount();
            var getToken = this.Auth.getToken();
            forkJoin([
                getToken,
                getEmail,
                getAccountInfo
            ])
                .pipe(map(function (result) {
                var mappedResult = {
                    bearToken: null,
                    userEmailAuth: null,
                    isUserImpersonated: false,
                };
                if (result.length > 2) {
                    var token = result[0];
                    var authenticatedUserEmail = result[1];
                    var aInfo = result[2];
                    mappedResult = {
                        bearToken: token,
                        userEmailAuth: authenticatedUserEmail,
                        isUserImpersonated: aInfo.isImpersonated,
                    };
                }
                else {
                    console.error("invalid response from auth(email) and setting services");
                }
                return mappedResult;
            }))
                .subscribe(function (data) {
                var _a;
                var userEmailAuth = data.userEmailAuth, isUserImpersonated = data.isUserImpersonated, bearToken = data.bearToken;
                var orderShippingAddress = (_a = _this.CartService.cartData) === null || _a === void 0 ? void 0 : _a.shippingAddress;
                // if user reload the page, cartData is blank
                if (orderShippingAddress === undefined) {
                    console.error('cart data is blank, redirecting to previous step');
                    _this.$location.path("/cart/checkout/shipping-and-delivery");
                }
                var sendData = {
                    token: bearToken,
                    isImpersonated: isUserImpersonated,
                    emailId: userEmailAuth,
                    page: 'checkout-payment',
                    shippingAddress: orderShippingAddress
                };
                _this.message('token', sendData);
            });
        }
    };
    PaymentCreditCardFrameController.prototype.message = function (eventType, request) {
        this.iframe.postMessage({
            eventtype: eventType,
            data: request,
            type: 'Emerson'
        }, '*');
    };
    PaymentCreditCardFrameController.prototype.paymentBackToDelivery = function () {
        this.$state.go('paymentBackToDelivery');
    };
    PaymentCreditCardFrameController.prototype.reviewOrder = function (selectedPayment) {
        var _this = this;
        this._$rootScope.localCVV = selectedPayment.verificationCode;
        this.CartService.addPayment(selectedPayment, 'CreditCard', null)
            .then(function () {
            _this._$rootScope.loading = false;
            _this.CartService.hideCVV(true);
            _this.$state.go('reviewOrder');
        })
            .catch(function () {
            _this.handleErrorMessage();
        });
    };
    PaymentCreditCardFrameController.prototype.clickReviewOrder = function () {
        var _this = this;
        sessionStorage.setItem('expressCheckoutStatus', false);
        if (this.selectedPaymentType !== 'Credit Card') {
            var selectedPayment = {};
            this._$rootScope.loading = true;
            this.CartService.addPayment(selectedPayment, this.selectedPaymentType, null)
                .then(function () {
                _this._$rootScope.loading = false;
                _this.disableRevieworder = false;
                _this.CartService.hideCVV(true);
                _this.$state.go('reviewOrder');
            })
                .catch(function () {
                _this.handleErrorMessage();
            });
        }
        else if (this.selectedPaymentType === 'Credit Card') {
            this.message('revieworder', {});
        }
    };
    PaymentCreditCardFrameController.prototype.handleErrorMessage = function () {
        this._$rootScope.loading = false;
        this.bannerMessage('An error has occurred while adding your payment method. Please try again.');
    };
    return PaymentCreditCardFrameController;
}());
export default PaymentCreditCardFrameController;
//# sourceMappingURL=payment-credit-card-frame.controller.js.map